<template>
  <div class="about">
    <div class="header1" v-if="ishow">
      <h3>to open up·cooperation·win-win</h3>
      <p>Chronic kidney disease life cycle management company</p>
      <!-- <p>国医通（北京）科技发展有限公司是一家聚焦肾病领域，集投资、<br>销售、服务、管理、运营、咨询为一体的综合服务平台公司。</p> -->
    </div>
    <div class="header1 style" v-else>
      <h3>Join us</h3>
      <p class="p2">
        You are welcome to join us. We will provide you with a competitive salary plan and a strong career development platform. We look forward to your joining us
      </p>
    </div>
    <!-- 菜单 -->
    <div class="about-menu">
      <div class="menu-head">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>About Us</el-breadcrumb-item>
          <el-breadcrumb-item>{{ BreadText }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <ul class="menu-content">
        <li
          v-for="item in aboutMenu"
          :key="item.id"
          :class="inRouter == item.name ? 'innovate-gl' : ''"
        >
          <router-link :to="{ name: item.name }" @click="toRouter(item.name)"
            >{{ item.text }}
          </router-link>
        </li>
      </ul>
    </div>
    <transition enter-active-class="animate__animated animate__fadeIn">
      <router-view />
    </transition>
  </div>
</template>

<script>
// import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      aboutMenu: [
        {
          id: 1,
          text: "The GYT Timeline",
          name: "fazhan",
        },
        {
          id: 2,
          text: "Talent recruitment",
          name: "rencai",
        },
      ],
      inRouter: this.$router.history.current.name,
      BreadText: this.$router.history.current.meta.title || "",
      ishow: true,
    };
  },
  created() {
     if (this.$router.history.current.name == "fazhan") {
        this.ishow = true;
      } else {
        this.ishow = false;
      }
  },
  watch: {
    $route(to) {
      let newpath = to.path.slice(1).split("/")[1];
      if (newpath == "fazhan") {
        this.ishow = true;
      } else {
        this.ishow = false;
      }
      this.inRouter = newpath;
      let MybreadText = this.aboutMenu.filter((item) => {
        return item.name == newpath;
      });
      this.BreadText = MybreadText[0].text;
    },
  },
  mounted() {
    // let wow = new WOW.WOW({
    //   boxClass: "wow",
    //   animateClass: "animated",
    //   offset: 0,
    //   mobile: true,
    //   live: true,
    // });
    // wow.init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.about {
  .p2{
    padding: 0 5rem;
    @media screen and (max-width: 540px) {
      padding: 0 10px;
    }
  }
  .header1 {
    height: 5.2632rem;
    width: 100%;
    background: url("../../assets/image/About/bg1.webp") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    text-align: center;
    @media screen and (max-width: 540px) {
      height: 250px;
      background-size: cover;
    }
    h3 {
      margin: 0;
      padding-top: 1.6421rem;
      padding-bottom: 0.4842rem;
      font-size: 0.4211rem;
      @media screen and (max-width: 540px) {
        padding: 73px 0 18px 0;
        font-size: 20px;
      }
    }
    p {
      font-size: 0.2526rem;
      line-height: 0.4842rem;
      @media screen and (max-width: 540px) {
        line-height: 25px;
        color: rgb(241, 241, 241);
        font-size: 12px;
      }
    }
  }
  .style {
    background: url("../../assets/image/About/bg2.webp") no-repeat;
    background-size: 150% 100%;
    background-position: 50% 50%;
  }
  .about-menu {
    height: 1.1789rem;
    margin: 0 0.8421rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    // justify-content: center;
    padding: 0 0.2316rem;
    @media screen and (max-width: 540px) {
      margin: 0;
      height: 56px;
    }
    align-items: center;
    .menu-head {
      padding-right: 1.6316rem;
      width: 3.6316rem;
      font-size: 0.2105rem !important;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-breadcrumb {
        font-size: 0.1895rem;
      }
    }
    .menu-content {
      display: flex;
      height: 100%;
      li {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 0.4737rem;
        font-size: 0.2105rem;
        box-sizing: border-box;
        border-bottom: 6px solid #0ca4eb00;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          margin: 0 15px;
        }
        a {
          font-weight: 700;
          list-style: none;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #666666;
        }
      }
    }
    // 菜单高亮
    .innovate-gl {
      color: #0ca6eb !important;
      // padding: 0.4737rem 0 0.3789rem 0;
      border-bottom-color: #0ca6eb !important;
      z-index: 999;
      a {
        color: #0ca6eb !important;
      }
    }
  }
  .about-menu::after {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    border-radius: 0.0316rem;
    background-color: #f1f1f1;
  }
}
</style>
